import styled, { css } from 'styled-components';

const colorStyle = css`
    color: ${({ color, theme, colorToken }) => color || theme.colors[colorToken] || theme.colors.Foreground};
`;
const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 30% 12px;
    border-radius: 8px;
    background: rgba(23, 204, 168, 0.1);
    text-align: center;
    align-items: center;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        padding: 15% 12px;
    `}
`;

const Icon = styled.div`
    margin-bottom: ${({ theme }) => theme.spacers.XL};
    height: 24px;
    width: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Title = styled.span`
    ${colorStyle}
    ${({ theme }) => css(theme.typography.SuperTinyHeadline)}
`;

export { Container, Icon, Title };
